import { call, put, takeEvery } from "redux-saga/effects"
import { GET_ADMIN_CALL_PRICES, UPDATE_ADMIN_CALL_PRICE } from "./actionTypes"
import { getAdminCallPricesSuccess, getAdminCallPricesError, updateAdminCallPriceSuccess, updateAdminCallPriceError } from "./actions"
import { genericGetRequest, genericPutRequest } from "../../helpers/sf_backend_helper"
import { AppConfiguration } from "config"
import { bsh_getAdminUserDetails } from "helpers/sf_browser_storage_helper"

function* onGetAdminCallPrices() {
  try {
    const user = bsh_getAdminUserDetails();
    const URL = `${AppConfiguration.BACKEND_URL}/api/v1/admin_call_prices`;
    const request_payload = {
      body: {},
      headers: {
        "Authorization": user.token,
        'Content-Type': 'application/json'
      }
    }
    const response = yield call(genericGetRequest, URL, request_payload.body, request_payload.headers)
    yield put(getAdminCallPricesSuccess(response))
  } catch (error) {
    yield put(getAdminCallPricesError(error))
  }
}

function* onUpdateAdminCallPrices(action) {
  try {
    const user = bsh_getAdminUserDetails();
    const URL = `${AppConfiguration.BACKEND_URL}/api/v1/admin_call_prices/${action.payload.id}`;
    const request_payload = {
      body: JSON.stringify({
        ...action.payload
      }),
      headers: {
        "Authorization": user.token,
        'Content-Type': 'application/json'
      }
    }
    const response = yield call(genericPutRequest, URL, request_payload)
    yield put(updateAdminCallPriceSuccess(response))
  } catch (error) {
    yield put(updateAdminCallPriceError(error))
  }
}

function* AdminCallPricesSaga() {
  yield takeEvery(GET_ADMIN_CALL_PRICES, onGetAdminCallPrices);
  yield takeEvery(UPDATE_ADMIN_CALL_PRICE, onUpdateAdminCallPrices);
}

export default AdminCallPricesSaga;